import React, { Component } from "react";
import "./RateBenefits.css";
import _ from "lodash";
import WeightBenefitsTabs from "./WeightBenefitsTabs/WeightBenefitsTabs";
import CreateWeightlModal from "./CreateWeightlModal/CreateWeightlModal";
import { ContentLowPriority } from "material-ui/svg-icons";
import { debug } from "util";
import AbilityToCompeteError from "./AbilityToCompeteError/AbilityToCompeteError";
import { Link } from "react-router-dom";
import jsPDF from "jspdf";
import rasterizeHTML from "rasterizehtml";
import { uniqBy } from "lodash";

class RateBenefits extends Component {
  constructor(props) {
    super(props);
    this.state = {
      goNextStep: false,
      tabs: [],
      competeData: [],
      oldData: [],
      competitorsGroupsData: [],
      benefitsData: [],
      countCCWT: [],
      totalScore: "",
    };
  }

  componentWillMount() {
    let customerSegmentData = {
      projectId: this.props.projectId,
      type: "segmentation"
    };
    let competeData = {
      projectId: this.props.projectId,
      type: "compete"
    };
    let challengeData = {
      type: "challenge",
      projectId: this.props.projectId
    };

    let competitorsData = {
      projectId: this.props.projectId,
      type: "competitors"
    };

    let advantageData = {
      projectId: this.props.projectId,
      type: "advantage"
    };

    this.props.getDifferentialAdvantage(advantageData);
    this.props.getCompetitorsGroups(competitorsData);
    this.props.getCustomerSegment(customerSegmentData);
    this.props.getCompete(competeData);
    this.props.getChallengeStatements(challengeData);
    //this.props.getBenefits(benefitData);
  }

  onNextButtonClick = () => {
    let stepValidation;
    let dataArr = 0;
    this.state.competeData.map(item => {
      dataArr = dataArr + +item.wt;
    });
    let k = this.state.tabs.length;
    let findZeroWt = this.state.competeData.find(
      r => r.wt === 0 || r.wt === "0"
    );
    let findZeroCCArray = [];
    let CCWT = 0
    this.state.competeData.map(item => {
      item.criticalCapacity.map(childItem => {
        findZeroCCArray.push(childItem);
        if(childItem.text === ''){
          childItem.text=null
        }
        CCWT+= +childItem.ccWt
      });
    });
    // let findZeroCC = findZeroCCArray.find(r => r.text === "");
    let findZeroCcWt = findZeroCCArray.find(
      r => r.ccWt === 0 || r.ccWt === "0"
    );
    if (dataArr === 100 * k && CCWT%100===0) {
      stepValidation = true;
    } else {
      stepValidation = false;
    }
    if (stepValidation) {
      let body = {
        id: this.props.differentialAdvantageData.getDifferentialAdvantageData
          .Items[0].id,
        projectId: this.props.projectId,
        type: "advantage",
        status: "finished",
        dataBenefits: this.state.competeData,
        advantage: this.props.differentialAdvantageData
          .getDifferentialAdvantageData.Items[0].advantage
      };
      this.setState({ goNextStep: true });
      this.props.editDifferentialAdvantage(body);
    } else {
      this.abilityToCompeteErrorModal();
    }
  };

  abilityToCompeteErrorModal = () => {
    this.setState({ abilityToCompeteError: !this.state.abilityToCompeteError });
  };

  componentWillReceiveProps(nextProps) {
    //competeData
    if (nextProps.differentialAdvantageData.getDifferentialAdvantageData.Items && !nextProps.differentialAdvantageData.getDifferentialAdvantageFetching && !_.isEmpty( nextProps.differentialAdvantageData.getDifferentialAdvantageData.Items) && _.isEmpty(this.state.competeData) ) {
      if(nextProps.differentialAdvantageData.getDifferentialAdvantageData.Items[0].newBenefits && this.state.newBenefits.length===0){
        this.setState({newBenefits: nextProps.differentialAdvantageData.getDifferentialAdvantageData.Items[0].newBenefits})
      }
      //competeData if differentialAdvantageData is empty
      if ( !nextProps.differentialAdvantageData.getDifferentialAdvantageData.Items[0].dataBenefits ) {
        if (
          nextProps.compete.competeData.Items &&
          _.isEmpty(this.state.competeData)
        ) {
          if (
            !nextProps.compete.competeFetching &&
            !_.isEmpty(nextProps.compete.competeData.Items) &&
            !_.isEmpty(nextProps.compete.customerSegmentData)
          ) {
            let competeData = [...this.state.competeData];
            let tabs = [];
            let oldGroupId = null;

            for (let item of nextProps.compete.competeData.Items[0]
              .dataBenefits) {
              if (!item.criticalCapacity) {
                let criticalCapacity = [
                  {
                    text: "",
                    ccWt: item.wt
                  }
                ];
                item.criticalCapacity = criticalCapacity;
              }
              competeData.push(item);
            }

            nextProps.compete.competeData.Items[0].dataBenefits.map(item => {
              let customerSegmentItem = nextProps.compete.customerSegmentData.find(
                r => r.groupId === item.groupId
              );
              let segmentData = customerSegmentItem.segments.find(
                r => r.segmentId === item.segmentId
              );
              tabs.push({
                groupId: item.groupId,
                groupName: customerSegmentItem.groupName,
                segmentId: item.segmentId,
                segmentName: segmentData.name
              });

              if (
                _.isEmpty(nextProps.compete.benefitsData) &&
                item.groupId !== oldGroupId
              ) {
                oldGroupId = item.groupId;

                let benefitData = {
                  projectId: this.props.projectId,
                  type: "benefitsLadder",
                  groupId: item.groupId
                };
                this.props.getBenefits(benefitData);
              }
            });
            this.setState(
              {
                competeData,
                editedData: true,
                createdData: false,
                tabs: _.uniqBy(tabs, v => [v.groupId, v.segmentId].join())
              },
              () => {
                this.totalScore();
                this.segmentTotalScore();
              }
            );
          }
        }
      }

      //competeData if differentialAdvantageData is not empty
      if ( nextProps.differentialAdvantageData.getDifferentialAdvantageData.Items[0].dataBenefits && _.isEmpty(this.state.competeData) ) {
        if (!_.isEmpty(nextProps.compete.customerSegmentData)) {
          let competeData = [...this.state.competeData];
          let tabs = [];
          let oldGroupId = null;
          for (let item of nextProps.compete.competeData.Items[0]
            .dataBenefits) {
            let customerSegmentItem = nextProps.compete.customerSegmentData.find(
              r => r.groupId === item.groupId
            );
            let segmentData = customerSegmentItem.segments.find(
              r => r.segmentId === item.segmentId
            );
            tabs.push({
              groupId: item.groupId,
              groupName: customerSegmentItem.groupName,
              segmentId: item.segmentId,
              segmentName: segmentData.name
            });
            if (
              _.isEmpty(nextProps.compete.benefitsData) &&
              item.groupId !== oldGroupId
            ) {
              oldGroupId = item.groupId;

              let benefitData = {
                projectId: this.props.projectId,
                type: "benefitsLadder",
                groupId: item.groupId
              };
              this.props.getBenefits(benefitData);
            }
          }
          tabs = _.uniqBy(tabs, v => [v.groupId, v.segmentId].join());
          for (let tab of tabs) {
            let data = _.filter(
              nextProps.differentialAdvantageData.getDifferentialAdvantageData
                .Items[0].dataBenefits,
              v => v.groupId === tab.groupId && v.segmentId === tab.segmentId
            );
            if (!data.length) {
              data = _.filter(
                nextProps.compete.competeData.Items[0].dataBenefits,
                v => v.groupId === tab.groupId && v.segmentId === tab.segmentId
              );
            }
            for (let item of data) {
              if (!item.criticalCapacity) {
                let criticalCapacity = [
                  {
                    text: "",
                    ccWt: item.wt
                  }
                ];
                item.criticalCapacity = criticalCapacity;
              }
              competeData.push(item);
            }
          }
          this.setState(
            {
              competeData,
              editedData: true,
              createdData: false,
              tabs
            },
            () => {
              this.totalScore();
              // this.segmentTotalScore();
            }
          );
        }
      }
    }

    //get competeOldData
    if (nextProps.compete.competeData.Items && _.isEmpty(this.state.oldData)) {
      if (
        !nextProps.compete.competeFetching &&
        !_.isEmpty(nextProps.compete.competeData.Items) &&
        !_.isEmpty(nextProps.compete.customerSegmentData)
      ) {
        let oldData = [];
        let oldGroupId = null;

        for (let item of nextProps.compete.competeData.Items[0].dataBenefits) {
          if (!item.criticalCapacity) {
            let criticalCapacity = [
              {
                text: "",
                ccWt: item.wt
              }
            ];
            item.criticalCapacity = criticalCapacity;
          }
          oldData.push(item);
        }

        for (let item of nextProps.compete.competeData.Items[0].dataBenefits) {
          if (
            _.isEmpty(nextProps.compete.benefitsData) &&
            item.groupId !== oldGroupId
          ) {
            oldGroupId = item.groupId;

            let benefitData = {
              projectId: this.props.projectId,
              type: "benefitsLadder",
              groupId: item.groupId
            };
            this.props.getBenefits(benefitData);
          }
        }
        //debugger
        this.setState({
          oldData
        });
      }
    }

    if (
      nextProps.compete.competitorsGroupsData.Count > 0 &&
      nextProps.compete.competitorsGroupsData.Items[0] &&
      nextProps.compete.competitorsGroupsData.Items[0].competitors &&
      !_.isEmpty(
        nextProps.compete.competitorsGroupsData.Items[0].competitors
      ) &&
      _.isEmpty(this.state.competitorsGroupsData)
    ) {
      let competitorsGroupsData = [...this.state.competitorsGroupsData];
      nextProps.compete.competitorsGroupsData.Items[0].competitors.map(item => {
        competitorsGroupsData.push({
          competitorId: item.competitorId,
          competitorName: item.competitorName,
          important: item.important,
          indirect: item.indirect,
          type: item.type
        });
      });

      this.setState({ competitorsGroupsData });
    }

    if (
      nextProps.compete.benefitsData &&
      !_.isEmpty(nextProps.compete.benefitsData) &&
      _.isEmpty(this.state.benefitsData)
    ) {
      let benefitsData = [...this.state.benefitsData];
      nextProps.compete.benefitsData.res.map(item => {
        benefitsData.push({
          benefitId: item.id,
          groupId: nextProps.compete.benefitsData.body.groupId,
          projectId: nextProps.compete.benefitsData.body.projectId,
          benefitName: item.name
        });
      });
      this.setState({ benefitsData });
    }

    if (
      nextProps.compete.benefitsData &&
      !_.isEmpty(nextProps.compete.benefitsData) &&
      this.state.createNewTabPending
    ) {
      this.state.competeData.map(item => {
        if (!item.benefitId) {
          nextProps.compete.benefitsData.res.map(benefitsItem => {
            if (item.groupId === nextProps.compete.benefitsData.body.groupId) {
              (item.benefitId = benefitsItem.id), (item.wt = 0);
              this.setState({ createNewTabPending: false });
            }
          });
        }
      });
    }

    if (
      !nextProps.differentialAdvantageData
        .createtDifferentialAdvantageFetching &&
      nextProps.differentialAdvantageData.createDifferentialAdvantageData &&
      nextProps.differentialAdvantageData.createDifferentialAdvantageData
        .statusCode === 200 &&
      this.state.goNextStep
    ) {
      this.props.groupStateNext();
    }
    if(!_.isEmpty(this.state.oldData)){
      let oldData = _.cloneDeep(this.state.oldData)
      let data = _.cloneDeep(this.state.competeData.find( r =>  r.new))
      if(data){
        let exsist = this.state.oldData.find(r=> r.groupId === data.groupId && r.segmentId === data.segmentId && r.benefitId === data.benefitId && r.new)
        if(!exsist){
          data.criticalCapacity.map(crit=>{
            crit.ccWt = 0
            crit.rating = "1"
            if(crit.competitors){
              crit.competitors.map(item=>{
                item.rating="1"
              })
            }
          })
          data.competitorTotal.map(item=>{
            item.value = 0
          })
          data.totalScore= 0
          data.wt = 0
          oldData.push(data)
          this.setState({oldData})
        }
      }
    }
  }

  onChangeWT = (e, data) => {
    let value = e.target.value;
    let competeData = _.cloneDeep(this.state.competeData);
    let oldData = _.cloneDeep(this.state.oldData);
    let changedItem = competeData.find(
      r =>
        r.groupId === data.groupId &&
        r.benefitId === data.benefitId &&
        r.segmentId === data.segmentId
    );
    let changedItemItemOld =  oldData.find(
      r =>
        r.groupId === data.groupId &&
        r.benefitId === data.benefitId &&
        r.segmentId === data.segmentId
    );

    changedItem.wt = value;

    if(!changedItem.new && changedItem.criticalCapacity.length===1 && !changedItemItemOld.new && changedItemItemOld.criticalCapacity.length===1){

      changedItem.criticalCapacity[0].ccWt=value
      changedItem.competitorTotal.map(item=>{
        item.value = +value
      })

      changedItem.totalScore = +value;
      // changedItemItemOld.criticalCapacity[0].ccWt=0
      // debugger
    }

    if(changedItem.new && changedItem.criticalCapacity.length===1 && changedItemItemOld.new && changedItemItemOld.criticalCapacity.length===1){

      changedItem.criticalCapacity[0].ccWt=value
      changedItem.competitorTotal.map(item=>{
        item.value = +value
      })

      changedItem.totalScore = +value;
      changedItemItemOld.criticalCapacity[0].ccWt=0
    }

    if(changedItem.new && changedItem.criticalCapacity.length===2 && changedItemItemOld.new &&
      changedItemItemOld.criticalCapacity.length===2){
      changedItem.criticalCapacity[0].ccWt=value/2
      changedItem.criticalCapacity[1].ccWt=value/2
      changedItem.totalScore = +value;
      changedItem.competitorTotal.map(item=>{
        item.value = +value
      })
      changedItemItemOld.criticalCapacity[0].ccWt=0
      changedItemItemOld.criticalCapacity[1].ccWt=0

    }

    if(!changedItem.new && changedItem.criticalCapacity.length===2 && !changedItemItemOld.new &&
      changedItemItemOld.criticalCapacity.length===2){
      changedItem.criticalCapacity[0].ccWt=value/2
      changedItem.criticalCapacity[1].ccWt=value/2
      changedItem.totalScore = +value;
      changedItem.competitorTotal.map(item=>{
        item.value = +value
      })
      changedItemItemOld.criticalCapacity[0].ccWt=0
      changedItemItemOld.criticalCapacity[1].ccWt=0

    }

    this.setState({ competeData ,oldData});
  };

  onChangeCCWT = (e, data, index) => {
    let value = e.target.value;

    let competeData = _.cloneDeep(this.state.competeData);

    let getCCWTParent = competeData.find(
      r =>
        r.groupId === data.groupId &&
        r.benefitId === data.benefitId &&
        r.segmentId === data.segmentId
    );

    getCCWTParent.criticalCapacity[index].ccWt = value;
    this.setState({ competeData });
  };

  onChangeCriticalCapability = (e, data, index) => {
    let value = e.target.value;
    let getCriticalCapabilityParent = this.state.competeData.find(
      r =>
        r.groupId === data.groupId &&
        r.benefitId === data.benefitId &&
        r.segmentId === data.segmentId
    );

    getCriticalCapabilityParent.criticalCapacity[index].text = value;
    this.setState({ competeData: this.state.competeData });
  };

  accountCCWT = data => {
    let numbersArr = [];

    this.state.competeData.map((i, index) => {
      if (data.groupId === i.groupId && data.segmentId === i.segmentId) {
        i.criticalCapacity.map((count, index) => {
          return numbersArr.push({
            ccWt: count.ccWt
          });
        });
      }
    });
    this.setState({ countCCWT: numbersArr });
  };

  onChangeCompetitors = e => {
    let value = e.target.value;
    for (let item of this.state.competitorsGroupsData) {
      if (item.groupId === value) {
        item.important = true;
      } else {
        item.important = false;
      }
    }
  };

  onChangeRatingValue = (e, data, index) => {
    let value = e.target.value;
    let competeData = _.cloneDeep(this.state.competeData);
    let getItem = competeData.find(
      r =>
        r.groupId === data.groupId &&
        r.segmentId === data.segmentId &&
        r.benefitId === data.benefitId
    );
    getItem.criticalCapacity[index].rating = value;
    this.setState({ competeData }, this.totalScore());
  };

  onChangeCompetitorsRatingValue = (e, data, groupData, index) => {
    let value = e.target.value;
    let competeData = _.cloneDeep(this.state.competeData);
    let getItem = competeData.find(
      r =>
        r.groupId === data.groupId &&
        r.segmentId === data.segmentId &&
        r.benefitId === data.benefitId
    );

    //getItem.criticalCapacity[index].rating = value

    let isExist = getItem.criticalCapacity[index].competitors
      ? getItem.criticalCapacity[index].competitors.find(
          r => r.competitorId === groupData.competitorId
        )
      : false;

    if (isExist) {
      isExist.rating = value;
    } else {
      if (getItem.criticalCapacity[index].competitors) {
        getItem.criticalCapacity[index].competitors.push({
          competitorId: groupData.competitorId,
          rating: value
        });
      } else {
        getItem.criticalCapacity[index].competitors = [];
        getItem.criticalCapacity[index].competitors.push({
          competitorId: groupData.competitorId,
          rating: value
        });
      }
    }
    this.segmentTotalScore();

    this.setState({ competeData });
  };

  printPage = () => {
    let html = `<div>
                        <h2 style='font-size: 18px; color: #333333; margin: 0px 0px 0px 0px'>Ability to Compete
                        </h2>
                        <p style="color: #333333; font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-style: italic; margin: 2px 0px 0px 0px">Results</p>
                        <br/>
                        ${this.state.tabs
                          .map((tabsItem, tabsKey) => {
                            let countWT = 0;
                            let countCCWT = 0;
                            let countScore = 0;
                            let countConpenScore = [];
                            const groupId = this.state.tabs.find(
                              r => r.groupId === tabsItem.groupId
                            ).groupId;
                            const segmentId = this.state.tabs.find(
                              r => r.segmentId === tabsItem.segmentId
                            ).segmentId;
                            return `<div style=" width: 815px; margin-bottom: 20px;height: 300px; ">
                                <div style="margin-bottom: 20px; width: 100%">
                                    <div>
                                        ${tabsItem.groupName}
                                    </div>
                                </div>
                                <div style='width: 500px; float: left;border-right: 2px dashed'>
                                    <div style='width: 100%; height: 30px;'></div>
                                    <table style="width: 100%">
                                        <thead>
                                            <tr style='width: 100%'>
                                                <th style="font-size: 12px; width: 12.5%;">Benefits Sought</th>
                                                <th style="font-size: 12px; width: 12.5%;">WT</th>
                                                <th style="font-size: 12px; width: 12.5%;">Critical Capability</th>
                                                <th style="font-size: 12px; width: 12.5%;">CC WT</th>
                                                <th style="font-size: 12px; width: 12.5%;">Rating <br/> (1-10)</th>
                                                <th style="font-size: 12px; width: 12.5%;">Score</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            ${this.state.competeData &&
                                              !_.isEmpty(
                                                this.state.benefitsData
                                              ) &&
                                              this.state.competeData
                                                .map((i, index) => {
                                                  if (
                                                    tabsItem.groupId ===
                                                      i.groupId &&
                                                    tabsItem.segmentId ===
                                                      i.segmentId
                                                  ) {
                                                    let benefitName;
                                                    this.props.benefits.benefitsLadderData.Items[0].data.map(
                                                      item => {
                                                        if (
                                                          item.groupId ===
                                                          i.groupId
                                                        ) {
                                                          benefitName = item.benefits.find(
                                                            r =>
                                                              r.id ===
                                                                i.benefitId &&
                                                              r.important
                                                          );
                                                        }
                                                      }
                                                    );
                                                    // let benefitName = this.state.benefitsData.find(r => r.groupId === i.groupId && r.benefitId === i.benefitId);
                                                    let oldI = this.state.oldData.find(
                                                      r =>
                                                        r.benefitId ===
                                                          i.benefitId &&
                                                        r.segmentId ===
                                                          i.segmentId &&
                                                        r.groupId === i.groupId
                                                    );
                                                    if(!oldI){
                                                      oldI = _.cloneDeep(this.state.competeData.find( r => r.benefitId === i.benefitId && r.segmentId === i.segmentId && r.groupId === i.groupId  && i.new))
                                                      oldI.totalScore= 0
                                                      oldI.wt = 0
                                                    }
                                                    return `<tr style="width: 100%">
                                                        <td style="font-size: 11px; width: 16%; text-align: center; background: #f5f5f6">
                                                            <div className='td-box' style='min-height: 50px'>
                                                                ${
                                                                  benefitName ? benefitName.name : i.name
                                                                }
                                                            </div>
                                                        </td>
                                                        <td style="font-size: 11px; width: 16%; text-align: center; background: #f5f5f6">
                                                            <div className='td-box' style=" position : relative; min-height: 50px">
                                                                ${i.wt}
                                                                ${
                                                                  i.wt -
                                                                    oldI.wt !==
                                                                  0
                                                                    ? `<div className="position-number" style=" position : absolute; top: -5px;
                                                                    left: 5px; font-size: 10px; font-weight: bold; ">
                                                                        ${i.wt -
                                                                          oldI.wt}
                                                                    </div>`
                                                                    : ""
                                                                }
                                                            </div>
                                                        </td>
                                                        <td style="font-size: 11px; width: 16%; text-align: center; background: #f5f5f6">
                                                            <div className='td-box' style='min-height: 50px'>
                                                                ${i.criticalCapacity
                                                                  .map(
                                                                    (
                                                                      critItem,
                                                                      index
                                                                    ) => {
                                                                      return `<div> ${
                                                                        critItem.text ? critItem.text : ''
                                                                      } </div>`;
                                                                    }
                                                                  ).join("")}
                                                            </div>
                                                        </td>
                                                        <td style="font-size: 11px; width: 16%; text-align: center; background: #f5f5f6">
                                                            <div className='td-box' style='min-height: 50px'>
                                                            ${i.criticalCapacity
                                                              .map(
                                                                (
                                                                  critItem,
                                                                  index
                                                                ) => {
                                                                  let ccWt =
                                                                    i
                                                                      .criticalCapacity
                                                                      .length >
                                                                    1
                                                                      ? critItem.ccWt
                                                                      : critItem.ccWt;
                                                                  let oldCritItem = oldI.criticalCapacity.find(
                                                                    r =>
                                                                      r.text ===
                                                                      critItem.text
                                                                  );
                                                                  return `<div style="position: relative">
                                                                    ${ccWt}
                                                                    ${
                                                                      ccWt -
                                                                        oldCritItem.ccWt !==
                                                                      0
                                                                        ? `<div className="position-number" style=" position : absolute; top: -5px;
                                                                        left: 5px; font-size: 10px; font-weight: bold; ">
                                                                            ${ccWt -
                                                                              oldCritItem.ccWt}
                                                                        </div>`
                                                                        : ""
                                                                    }
                                                                </div>`;
                                                                }
                                                              ).join("")}
                                                            </div>
                                                        </td>
                                                        <td style="font-size: 11px; width: 16%; text-align: center;  background: #f5f5f6">
                                                            <div className='td-box' style='min-height: 50px'>
                                                                ${i.criticalCapacity
                                                                  .map(
                                                                    (
                                                                      critItem,
                                                                      index
                                                                    ) => {
                                                                      let oldcriticalCapacity = oldI.criticalCapacity.find(
                                                                        r =>
                                                                          r.text ===
                                                                          critItem.text
                                                                      );

                                                                      let val = critItem.rating
                                                                        ? critItem.rating
                                                                        : "1";

                                                                      let oldVal = oldcriticalCapacity.rating
                                                                        ? +oldcriticalCapacity.rating
                                                                        : 1;

                                                                      return `<div style="position: relative; ">
                                                                        ${val}
                                                                        ${
                                                                          +val -
                                                                            +oldVal !==
                                                                          0
                                                                            ? `<div className="position-number" style="position : absolute; top: -5px;
                                                                            left: 5px; font-size: 10px; font-weight: bold;">
                                                                                ${+val -
                                                                                  +oldVal}
                                                                            </div> `
                                                                            : ""
                                                                        }

                                                                    </div>`;
                                                                    }
                                                                  ).join("")}
                                                            </div>
                                                        </td>
                                                        <td style="font-size: 11px; width: 16%; text-align: center; background: #f5f5f6">
                                                            <div className='td-box' style='min-height: 50px'>
                                                                ${i.criticalCapacity
                                                                  .map(
                                                                    (
                                                                      critItem,
                                                                      index
                                                                    ) => {
                                                                      let valScore = critItem.rating
                                                                        ? +critItem.ccWt *
                                                                          +critItem.rating
                                                                        : +critItem.ccWt;
                                                                      countScore =
                                                                        +countScore +
                                                                        valScore;

                                                                      return `<div className='score-box' style="position: relative">
                                                                            ${valScore}
                                                                            ${
                                                                              +valScore -
                                                                                +oldI.totalScore !==
                                                                              0
                                                                                ? `<div className="position-number" style="position : absolute; top: -5px;
                                                                            left: 5px; font-size: 10px; font-weight: bold; background: #ccc">
                                                                                    ${+valScore -
                                                                                      +oldI.totalScore}
                                                                                </div> `
                                                                                : ""
                                                                            }
                                                                        </div>`;
                                                                    }
                                                                  ).join("")}
                                                            </div>
                                                        </td>
                                                    </tr>`;
                                                  }
                                                })
                                                .join("")}

                                            <tr style="width: 100%">
                                                <td style="font-size: 11px; width: 16%; text-align: center"></td>
                                                <td style="font-size: 11px; width: 16%; text-align: center">
                                                    <strong>

                                                    </strong>
                                                </td>
                                                <td style="font-size: 11px; width: 16%; text-align: center"></td>
                                                <td style="font-size: 11px; width: 16%; text-align: center">
                                                    <strong>

                                                    </strong>
                                                </td>
                                                <td style="font-size: 11px; width: 16%; text-align: center"></td>
                                                <td style="font-size: 11px; width: 16%; text-align: center">
                                                    <strong>
                                                        ${countScore}
                                                    </strong>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div style='width: 300px; float: left'>
                                    <div style='width: 300px; height: 30px; margin-left: 10px'>
                                    ${this.state.competeData.find(
                                      r =>
                                        r.groupId === tabsItem.groupId &&
                                        r.segmentId === tabsItem.segmentId
                                    ).competitorTotal &&
                                      _.uniqBy(
                                        this.state.competeData.find(
                                          r =>
                                            r.groupId === tabsItem.groupId &&
                                            r.segmentId === tabsItem.segmentId
                                        ).competitorTotal,
                                        "competitorId"
                                      )
                                        .map((item, index) => {
                                          return `<div style='width: 33%; float: left;'>
                                                ${this.state.competitorsGroupsData
                                                  .map((name, key) => {
                                                    if (
                                                      item.competitorId ===
                                                      name.competitorId
                                                    )
                                                      return name.competitorName;
                                                  }).join("")}
                                                </div>`;
                                        }).join("")}
                                    </div>
                                    <table style="width: 300px; margin-left: -8px">
                                        <thead style='width: 300px'>
                                            <tr style='width: 100%; padding: 0px;'>
                                                ${this.state.competitorsGroupsData
                                                  .map((name, key) => {
                                                    if (name.important) {
                                                      return `
                                                            <th style='width: 33.3%; padding: 0px;'>
                                                                <th style='width: 49%; font-size: 12px; padding: 0px; text-alight: center'>Rating <br/> (1-10)</th>
                                                                <th style='width: 49%; font-size: 12px; padding: 0px; text-alight: center'>Score</th>
                                                            </th>
                                                        `;
                                                    }
                                                  }).join("")}
                                            </tr>
                                        </thead>
                                        <tbody style="width: 100%">
                                            ${this.state.competeData &&
                                              !_.isEmpty(
                                                this.state.benefitsData
                                              ) &&
                                              this.state.competeData
                                                .map((i, index) => {
                                                  if (
                                                    tabsItem.groupId ===
                                                      i.groupId &&
                                                    tabsItem.segmentId ===
                                                      i.segmentId
                                                  ) {
                                                    let oldI = this.state.oldData.find(
                                                      r =>
                                                        r.benefitId ===
                                                          i.benefitId &&
                                                        r.segmentId ===
                                                          i.segmentId &&
                                                        r.groupId === i.groupId
                                                    );

                                                    return `<tr style="width: 100%">
                                                            ${this.state.competitorsGroupsData
                                                              .map(
                                                                (
                                                                  competitorsData,
                                                                  key
                                                                ) => {
                                                                  if (
                                                                    competitorsData.important
                                                                  ) {
                                                                    return `<td style='width: 33.3%'>
                                                                        <td style='width: 50%; font-size: 11px; text-align: center; background: #f5f5f6; height: 50px;padding: 15px 23px'>
                                                                        ${i.criticalCapacity
                                                                          .map(
                                                                            (
                                                                              critItem,
                                                                              index
                                                                            ) => {
                                                                              let defData = critItem.competitors
                                                                                ? critItem.competitors.find(
                                                                                    r =>
                                                                                      r.competitorId ===
                                                                                      competitorsData.competitorId
                                                                                  )
                                                                                : false;

                                                                              let oldDefData = oldI.criticalCapacity.find(
                                                                                r =>
                                                                                  r.text ===
                                                                                  critItem.text
                                                                              );

                                                                              let val = oldDefData.competitors
                                                                                ? oldDefData.competitors.find(
                                                                                    r =>
                                                                                      r.competitorId ===
                                                                                      competitorsData.competitorId
                                                                                  )
                                                                                : false;

                                                                              let newVal = defData
                                                                                ? defData.rating
                                                                                : 1;

                                                                              let oldVal = val
                                                                                ? val.rating
                                                                                : 1;

                                                                              return `<div style="position: relative;">
                                                                            ${
                                                                              defData
                                                                                ? defData.rating
                                                                                : 1
                                                                            }

                                                                            ${
                                                                              +newVal -
                                                                                +oldVal !==
                                                                              0
                                                                                ? `<div style="position : absolute; top: -25px;
                                                                                left: -23px; font-size: 10px; font-weight: bold; background: #ccc;padding: 2px">
                                                                                    ${+newVal -
                                                                                      +oldVal}
                                                                                </div>`
                                                                                : ""
                                                                            }

                                                                            </div>`;
                                                                            }
                                                                          )
                                                                          .join(
                                                                            ""
                                                                          )}
                                                                        </td>
                                                                        <td style='width: 50%; font-size: 11px; text-align: center; background: #f5f5f6;height: 50px'>
                                                                        ${i.criticalCapacity.map((critItem,index) => {
                                                                            let oldItem = oldI.criticalCapacity.find(r => r.text === critItem.text)

                                                                            let rateVal = critItem.competitors ? critItem.competitors.find(r => r.competitorId === competitorsData.competitorId) : { rating: '1' };

                                                                            let rateOldVal = oldItem.competitors ? oldItem.competitors.find(r => r.competitorId === competitorsData.competitorId) : { rating: '1' };

                                                                            let valScore = rateVal ? +critItem.ccWt * +rateVal.rating : +critItem.ccWt;

                                                                            let valOldScore = rateOldVal ? +oldItem.ccWt * +rateOldVal.rating : +oldItem.ccWt;

                                                                            let newVal = valScore ? valScore : critItem.ccWt;

                                                                            let oldVal = valOldScore ? valOldScore : critItem.ccWt;
                                                                            countConpenScore.push({
                                                                                score: valScore,
                                                                                competitorId: competitorsData.competitorId,
                                                                                difference: +newVal - +oldVal
                                                                            })

                                                                              return `<div style='width: 100%; text-align: center; font-size: 11px; position: relative;'>
                                                                                ${
                                                                                  valScore
                                                                                    ? valScore
                                                                                    : critItem.ccWt
                                                                                }

                                                                                ${
                                                                                  +newVal -
                                                                                    +oldVal !==
                                                                                  0
                                                                                    ? `<div style="position : absolute; top: -25px;
                                                                                    left: 1px; font-size: 10px; font-weight: bold;background: #ccc">
                                                                                    ${+newVal -
                                                                                      +oldVal}
                                                                                    </div> `
                                                                                    : ""
                                                                                }
                                                                            </div> `;
                                                                            }
                                                                          )
                                                                          .join(
                                                                            ""
                                                                          )}
                                                                        </td>

                                                                    </td>
                                                                    `;
                                                                  }
                                                                }
                                                              ).join("")}
                                                        </tr>`;
                                                  }
                                                }).join("")}
                                                <tr class='last-row'>
                                                    ${
                                                        this.state.competitorsGroupsData.map((competitorsData, key) => {
                                                            if (competitorsData.important) {
                                                                let val = 0;
                                                                let diff = 0
                                                                countConpenScore.map((item, key) => {
                                                                    if (item.competitorId === competitorsData.competitorId) {
                                                                        val = val + +item.score
                                                                        diff = diff + +item.difference
                                                                    }
                                                                })
                                                                return `<td className='parent-td'>
                                                                <td className='child-td'></td>
                                                                <td className=' child-td first-value'>
                                                                <strong>${val}</strong>
                                                                </td>
                                                            </td>`
                                                            }
                                                        }).join("")

                                                    }
                                                </tr>
                                        </tbody>
                                    </table>
                                </div>

                            </div>`;
                          })
                          .join("")}
        </div>`;
    let w = window.open();
    w.document.write(html);
    w.print();
    w.close();
  };

  printDocument = e => {
    e.preventDefault();
    const canvas = document.createElement("canvas");
    canvas.height = 1000;
    canvas.width = 1500;
    // canvas.textAlign = "center";

    let html = `<div>
    <h2 style='font-size: 18px; color: #333333; margin: 0px 0px 0px 0px'>Ability to Compete
    </h2>
    <p style="color: #333333; font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-style: italic; margin: 2px 0px 0px 0px">Results</p>
    <br/>
    ${this.state.tabs
      .map((tabsItem, tabsKey) => {
        let countWT = 0;
        let countCCWT = 0;
        let countScore = 0;
        let countConpenScore = [];
        const groupId = this.state.tabs.find(
          r => r.groupId === tabsItem.groupId
        ).groupId;
        const segmentId = this.state.tabs.find(
          r => r.segmentId === tabsItem.segmentId
        ).segmentId;
        return `<div style=" width: 714px; margin-bottom: 20px;height: 300px; ">
            <div style="margin-bottom: 20px; width: 100%">
                <div>
                    ${tabsItem.groupName}
                </div>
            </div>
            <div style='width: 400px; float: left;border-right: 2px dashed'>
                <div style='width: 100%; height: 30px;'></div>
                <table style="width: 100%">
                    <thead>
                        <tr style='width: 100%'>
                            <th style="font-size: 12px; width: 12.5%;">Benefits Sought</th>
                            <th style="font-size: 12px; width: 12.5%;">WT</th>
                            <th style="font-size: 12px; width: 12.5%;">Critical Capability</th>
                            <th style="font-size: 12px; width: 12.5%;">CC WT</th>
                            <th style="font-size: 12px; width: 12.5%;">Rating <br/> (1-10)</th>
                            <th style="font-size: 12px; width: 12.5%;">Score</th>
                        </tr>
                    </thead>
                    <tbody>
                        ${this.state.competeData &&
                          !_.isEmpty(
                            this.state.benefitsData
                          ) &&
                          this.state.competeData
                            .map((i, index) => {
                              if (
                                tabsItem.groupId ===
                                  i.groupId &&
                                tabsItem.segmentId ===
                                  i.segmentId
                              ) {
                                let benefitName;
                                this.props.benefits.benefitsLadderData.Items[0].data.map(
                                  item => {
                                    if (
                                      item.groupId ===
                                      i.groupId
                                    ) {
                                      benefitName = item.benefits.find(
                                        r =>
                                          r.id ===
                                            i.benefitId &&
                                          r.important
                                      );
                                    }
                                  }
                                );
                                // let benefitName = this.state.benefitsData.find(r => r.groupId === i.groupId && r.benefitId === i.benefitId);
                                let oldI = this.state.oldData.find(
                                  r =>
                                    r.benefitId ===
                                      i.benefitId &&
                                    r.segmentId ===
                                      i.segmentId &&
                                    r.groupId === i.groupId
                                );
                                if(!oldI){
                                  oldI = _.cloneDeep(this.state.competeData.find( r => r.benefitId === i.benefitId && r.segmentId === i.segmentId && r.groupId === i.groupId  && i.new))
                                  oldI.totalScore= 0
                                  oldI.wt = 0
                                }
                                return `<tr style="width: 100%">
                                    <td style="font-size: 11px; width: 16%; text-align: center; background: #f5f5f6">
                                        <div className='td-box' style='min-height: 50px'>
                                            ${
                                              benefitName ? benefitName.name : i.name
                                            }
                                        </div>
                                    </td>
                                    <td style="font-size: 11px; width: 16%; text-align: center; background: #f5f5f6">
                                        <div className='td-box' style=" position : relative; min-height: 50px">
                                            ${i.wt}
                                            ${
                                              i.wt -
                                                oldI.wt !==
                                              0
                                                ? `<div className="position-number" style=" position : absolute; top: -5px;
                                                left: 5px; font-size: 10px; font-weight: bold; ">
                                                    ${i.wt -
                                                      oldI.wt}
                                                </div>`
                                                : ""
                                            }
                                        </div>
                                    </td>
                                    <td style="font-size: 11px; width: 16%; text-align: center; background: #f5f5f6">
                                        <div className='td-box' style='min-height: 50px'>
                                            ${i.criticalCapacity
                                              .map(
                                                (
                                                  critItem,
                                                  index
                                                ) => {
                                                  return `<div> ${
                                                    critItem.text ? critItem.text : ''
                                                  } </div>`;
                                                }
                                              ).join("")}
                                        </div>
                                    </td>
                                    <td style="font-size: 11px; width: 16%; text-align: center; background: #f5f5f6">
                                        <div className='td-box' style='min-height: 50px'>
                                        ${i.criticalCapacity
                                          .map(
                                            (
                                              critItem,
                                              index
                                            ) => {
                                              let ccWt =
                                                i
                                                  .criticalCapacity
                                                  .length >
                                                1
                                                  ? critItem.ccWt
                                                  : critItem.ccWt;
                                              let oldCritItem = oldI.criticalCapacity.find(
                                                r =>
                                                  r.text ===
                                                  critItem.text
                                              );
                                              return `<div style="position: relative">
                                                ${ccWt}
                                                ${
                                                  ccWt -
                                                    oldCritItem.ccWt !==
                                                  0
                                                    ? `<div className="position-number" style=" position : absolute; top: -5px;
                                                    left: 5px; font-size: 10px; font-weight: bold; ">
                                                        ${ccWt -
                                                          oldCritItem.ccWt}
                                                    </div>`
                                                    : ""
                                                }
                                            </div>`;
                                            }
                                          ).join("")}
                                        </div>
                                    </td>
                                    <td style="font-size: 11px; width: 16%; text-align: center;  background: #f5f5f6">
                                        <div className='td-box' style='min-height: 50px'>
                                            ${i.criticalCapacity
                                              .map(
                                                (
                                                  critItem,
                                                  index
                                                ) => {
                                                  let oldcriticalCapacity = oldI.criticalCapacity.find(
                                                    r =>
                                                      r.text ===
                                                      critItem.text
                                                  );

                                                  let val = critItem.rating
                                                    ? critItem.rating
                                                    : "1";

                                                  let oldVal = oldcriticalCapacity.rating
                                                    ? +oldcriticalCapacity.rating
                                                    : 1;

                                                  return `<div style="position: relative; ">
                                                    ${val}
                                                    ${
                                                      +val -
                                                        +oldVal !==
                                                      0
                                                        ? `<div className="position-number" style="position : absolute; top: -5px;
                                                        left: 5px; font-size: 10px; font-weight: bold;">
                                                            ${+val -
                                                              +oldVal}
                                                        </div> `
                                                        : ""
                                                    }

                                                </div>`;
                                                }
                                              ).join("")}
                                        </div>
                                    </td>
                                    <td style="font-size: 11px; width: 16%; text-align: center; background: #f5f5f6">
                                        <div className='td-box' style='min-height: 50px'>
                                            ${i.criticalCapacity
                                              .map(
                                                (
                                                  critItem,
                                                  index
                                                ) => {
                                                  let valScore = critItem.rating
                                                    ? +critItem.ccWt *
                                                      +critItem.rating
                                                    : +critItem.ccWt;
                                                  countScore =
                                                    +countScore +
                                                    valScore;

                                                  return `<div className='score-box' style="position: relative">
                                                        ${valScore}
                                                        ${
                                                          +valScore -
                                                            +oldI.totalScore !==
                                                          0
                                                            ? `<div className="position-number" style="position : absolute; top: -5px;
                                                        left: 5px; font-size: 10px; font-weight: bold; background: #ccc">
                                                                ${+valScore -
                                                                  +oldI.totalScore}
                                                            </div> `
                                                            : ""
                                                        }
                                                    </div>`;
                                                }
                                              ).join("")}
                                        </div>
                                    </td>
                                </tr>`;
                              }
                            })
                            .join("")}

                        <tr style="width: 100%">
                            <td style="font-size: 11px; width: 16%; text-align: center"></td>
                            <td style="font-size: 11px; width: 16%; text-align: center">
                                <strong>

                                </strong>
                            </td>
                            <td style="font-size: 11px; width: 16%; text-align: center"></td>
                            <td style="font-size: 11px; width: 16%; text-align: center">
                                <strong>

                                </strong>
                            </td>
                            <td style="font-size: 11px; width: 16%; text-align: center"></td>
                            <td style="font-size: 11px; width: 16%; text-align: center">
                                <strong>
                                    ${countScore}
                                </strong>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div style='width: 300px; float: left'>
                <div style='width: 300px; height: 30px; margin-left: 10px'>
                ${this.state.competeData.find(
                  r =>
                    r.groupId === tabsItem.groupId &&
                    r.segmentId === tabsItem.segmentId
                ).competitorTotal &&
                  _.uniqBy(
                    this.state.competeData.find(
                      r =>
                        r.groupId === tabsItem.groupId &&
                        r.segmentId === tabsItem.segmentId
                    ).competitorTotal,
                    "competitorId"
                  )
                    .map((item, index) => {
                      return `<div style='width: 33%; float: left;'>
                            ${this.state.competitorsGroupsData
                              .map((name, key) => {
                                if (
                                  item.competitorId ===
                                  name.competitorId
                                )
                                  return name.competitorName;
                              }).join("")}
                            </div>`;
                    }).join("")}
                </div>
                <table style="width: 300px; margin-left: -8px">
                    <thead style='width: 300px'>
                        <tr style='width: 100%; padding: 0px;'>
                            ${this.state.competitorsGroupsData
                              .map((name, key) => {
                                if (name.important) {
                                  return `
                                        <th style='width: 33.3%; padding: 0px;'>
                                            <th style='width: 49%; font-size: 12px; padding: 0px; text-alight: center'>Rating <br/> (1-10)</th>
                                            <th style='width: 49%; font-size: 12px; padding: 0px; text-alight: center'>Score</th>
                                        </th>
                                    `;
                                }
                              }).join("")}
                        </tr>
                    </thead>
                    <tbody style="width: 100%">
                        ${this.state.competeData &&
                          !_.isEmpty(
                            this.state.benefitsData
                          ) &&
                          this.state.competeData
                            .map((i, index) => {
                              if (
                                tabsItem.groupId ===
                                  i.groupId &&
                                tabsItem.segmentId ===
                                  i.segmentId
                              ) {
                                let oldI = this.state.oldData.find(
                                  r =>
                                    r.benefitId ===
                                      i.benefitId &&
                                    r.segmentId ===
                                      i.segmentId &&
                                    r.groupId === i.groupId
                                );

                                return `<tr style="width: 100%">
                                        ${this.state.competitorsGroupsData
                                          .map(
                                            (
                                              competitorsData,
                                              key
                                            ) => {
                                              if (
                                                competitorsData.important
                                              ) {
                                                return `<td style='width: 33.3%'>
                                                    <td style='width: 50%; font-size: 11px; text-align: center; background: #f5f5f6; height: 50px;padding-left: 23px; padding-right: 23px'>
                                                    ${i.criticalCapacity
                                                      .map(
                                                        (
                                                          critItem,
                                                          index
                                                        ) => {
                                                          let defData = critItem.competitors
                                                            ? critItem.competitors.find(
                                                                r =>
                                                                  r.competitorId ===
                                                                  competitorsData.competitorId
                                                              )
                                                            : false;

                                                          let oldDefData = oldI.criticalCapacity.find(
                                                            r =>
                                                              r.text ===
                                                              critItem.text
                                                          );

                                                          let val = oldDefData.competitors
                                                            ? oldDefData.competitors.find(
                                                                r =>
                                                                  r.competitorId ===
                                                                  competitorsData.competitorId
                                                              )
                                                            : false;

                                                          let newVal = defData
                                                            ? defData.rating
                                                            : 1;

                                                          let oldVal = val
                                                            ? val.rating
                                                            : 1;

                                                          return `<div style="position: relative;">
                                                        ${
                                                          defData
                                                            ? defData.rating
                                                            : 1
                                                        }

                                                        ${
                                                          +newVal -
                                                            +oldVal !==
                                                          0
                                                            ? `<div style="position : absolute; top: -25px;
                                                            left: -23px; font-size: 10px; font-weight: bold; background: #ccc;padding: 2px">
                                                                ${+newVal -
                                                                  +oldVal}
                                                            </div>`
                                                            : ""
                                                        }

                                                        </div>`;
                                                        }
                                                      )
                                                      .join(
                                                        ""
                                                      )}
                                                    </td>
                                                    <td style='width: 50%; font-size: 11px; text-align: center; background: #f5f5f6;height: 50px'>
                                                    ${i.criticalCapacity.map((critItem,index) => {
                                                        let oldItem = oldI.criticalCapacity.find(r => r.text === critItem.text)

                                                        let rateVal = critItem.competitors ? critItem.competitors.find(r => r.competitorId === competitorsData.competitorId) : { rating: '1' };

                                                        let rateOldVal = oldItem.competitors ? oldItem.competitors.find(r => r.competitorId === competitorsData.competitorId) : { rating: '1' };

                                                        let valScore = rateVal ? +critItem.ccWt * +rateVal.rating : +critItem.ccWt;

                                                        let valOldScore = rateOldVal ? +oldItem.ccWt * +rateOldVal.rating : +oldItem.ccWt;

                                                        let newVal = valScore ? valScore : critItem.ccWt;

                                                        let oldVal = valOldScore ? valOldScore : critItem.ccWt;
                                                        countConpenScore.push({
                                                            score: valScore,
                                                            competitorId: competitorsData.competitorId,
                                                            difference: +newVal - +oldVal
                                                        })

                                                          return `<div style='width: 100%; text-align: center; font-size: 11px; position: relative;'>
                                                            ${
                                                              valScore
                                                                ? valScore
                                                                : critItem.ccWt
                                                            }

                                                            ${
                                                              +newVal -
                                                                +oldVal !==
                                                              0
                                                                ? `<div style="position : absolute; top: -25px;
                                                                left: 1px; font-size: 10px; font-weight: bold;background: #ccc">
                                                                ${+newVal -
                                                                  +oldVal}
                                                                </div> `
                                                                : ""
                                                            }
                                                        </div> `;
                                                        }
                                                      )
                                                      .join(
                                                        ""
                                                      )}
                                                    </td>

                                                </td>
                                                `;
                                              }
                                            }
                                          ).join("")}
                                    </tr>`;
                              }
                            }).join("")}
                            <tr class='last-row'>
                                ${
                                    this.state.competitorsGroupsData.map((competitorsData, key) => {
                                        if (competitorsData.important) {
                                            let val = 0;
                                            let diff = 0
                                            countConpenScore.map((item, key) => {
                                                if (item.competitorId === competitorsData.competitorId) {
                                                    val = val + +item.score
                                                    diff = diff + +item.difference
                                                }
                                            })
                                            return `<td className='parent-td'>
                                            <td className='child-td'></td>
                                            <td className=' child-td first-value'>
                                            <strong>${val}</strong>
                                            </td>
                                        </td>`
                                        }
                                    }).join("")

                                }
                            </tr>
                    </tbody>
                </table>
            </div>

        </div>`;
      })
      .join("")}
</div>`;

    rasterizeHTML.drawHTML(html, canvas).then(renderResult => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "pt", "a4");
      pdf.addImage(imgData, "JPEG", 0, 0);
      pdf.save("differential.pdf");
    });
  };

  downloadPDF = e => {
    this.printDocument(e);
  };

  elementInfiniteLoad() {
    return (
      <div className="col-sm-12">
        <div className="spinner3">
          <div className="rect1" />
          <div className="rect2" />
          <div className="rect3" />
          <div className="rect4" />
          <div className="rect5" />
        </div>
      </div>
    );
  }

  segmentTotalScore = () => {
    this.setState({
      competeData: this.props.compete.competeData.Items[0].dataBenefits
    });
  };

  totalScore = () => {
    let totalCountScore = 0;
    this.state.competeData.map((i, index) => {
      let countScore = 0;
      i.criticalCapacity.map((critItem, index) => {
        let valScore = critItem.rating
          ? +critItem.ccWt * +critItem.rating
          : +critItem.ccWt;
        totalCountScore = +countScore + valScore;
        countScore = +countScore + valScore;
      });
      i.totalScore = countScore;
    });
    this.setState({ totalScore: totalCountScore });
  };
  onDelete = i => {
    let competeData = this.state.competeData;
    let newCompeteData = [];
    competeData.map(item => {
      if (
        item.groupId !== i.groupId ||
        item.segmentId !== i.segmentId ||
        item.benefitId !== i.benefitId
      ) {
        newCompeteData.push(item);
      }
    });
    this.setState({ competeData: newCompeteData });
  };
  onAdd = (groupId, segmentId, benefitId) => {
    let competeData = this.state.competeData;

    this.state.oldData.map(item => {
      if (
        item.groupId === groupId &&
        item.segmentId === segmentId &&
        item.benefitId === benefitId
      ) {
        competeData.push(item);
      }
    });
    this.setState({ competeData });
  };
  onAddNewBenefit = (groupId, segmentId)=>{
    if(groupId && segmentId){
      let competeData = this.state.competeData;
      let oldData = this.state.oldData
      const uuidv1 = require('uuid/v1');
      let competitorTotal = [];
      let id=uuidv1();
      let competitor = []
      this.state.competeData.map(item=>{
        if(item.groupId === groupId && item.segmentId === segmentId && competitorTotal.length === 0){
          let competitors = _.uniqBy(item.competitorTotal, 'competitorId')
          competitors.map(comp=>{
              competitorTotal.push({
              competitorId: comp.competitorId,
              value: 0,
              id: id
            })
            competitor.push({
              competitorId: comp.competitorId,
              rating: "1"
            })
          })
       }
      })
      let newBenefit = {
        groupId: groupId,
        segmentId: segmentId,
        wt: 0,
        totalScore: 0,
        name: '',
        criticalCapacity: [{
          ccWt: 0,
          text: '',
          competitors: competitor,
          id: id
        }],
        competitorTotal: competitorTotal,
        benefitId: id,
        new: true
      }
      competeData.push(newBenefit);
      oldData.push(newBenefit)
      this.setState({competeData,oldData})
    }

  }
  onChangeNewBenefitName=(groupId,segmentId,benefitId,value)=>{
    let competeData = this.state.competeData;
    let oldData = this.state.oldData;
    competeData.map(compete=>{
      if(compete.groupId===groupId && compete.segmentId === segmentId && compete.benefitId === benefitId){
        compete.name = value
      }
    })
    oldData.map(compete=>{
      if(compete.groupId===groupId && compete.segmentId === segmentId && compete.benefitId === benefitId){
        compete.name = value
      }
    })
    this.setState({competeData,oldData})
  }
  onClickPlus = (data) => {
    let getCriticalCapabilityParent = this.state.competeData.find(r => r.groupId === data.groupId && r.benefitId === data.benefitId && r.segmentId === data.segmentId);
    let oldgetCriticalCapabilityParent = this.state.oldData.find(r => r.groupId === data.groupId && r.benefitId === data.benefitId && r.segmentId === data.segmentId)
    const uuidv1 = require('uuid/v1');
    let id=uuidv1()
    getCriticalCapabilityParent.criticalCapacity.push({
        text: null,
        ccWt: getCriticalCapabilityParent.wt,
        id: id
    })
    oldgetCriticalCapabilityParent.criticalCapacity.push({
      text: null,
      ccWt: oldgetCriticalCapabilityParent.wt,
      id: id
  })

    getCriticalCapabilityParent.criticalCapacity.map((count,index )=> {
        return count.ccWt = count.ccWt / 2
    })
    oldgetCriticalCapabilityParent.criticalCapacity.map((count,index )=> {
      return count.ccWt = count.ccWt / 2
  })


    this.setState({ competeData : this.state.competeData}, () => { this.accountCCWT(data) })
}

onClickMin = (data) => {
    let getCriticalCapabilityParent = this.state.competeData.find(r => r.groupId === data.groupId && r.benefitId === data.benefitId && r.segmentId === data.segmentId);
    getCriticalCapabilityParent.criticalCapacity.splice(-1,1)

    getCriticalCapabilityParent.criticalCapacity[0].ccWt = getCriticalCapabilityParent.wt;
    this.setState({ competeData : this.state.competeData }, () => { this.accountCCWT(data) } )
}
  render() {
    return (
      <div className="criteria-content">
        <div className="step-bar">
          <div className="step step-three arrow-step">
            <p>Step 1</p>
          </div>
          <div
            className={
              this.props.result
                ? "step step-three arrow-step"
                : "step step-three arrow-step active-step"
            }
          >
            <p>Step 2</p>
          </div>
          <div
            className={
              this.props.result
                ? "step step-three arrow-step active-step"
                : "step step-three arrow-step"
            }
          >
            <p>Result</p>
          </div>
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <h5>Differential Advantage</h5>
            </div>
          </div>
          {!this.props.compete.competeFetching && (
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <div className="col-md-8">
                      {this.props.result ?
                          <div className="criteria-title-box">
                            <h5>Results</h5>
                          </div>
                          :
                          <div className="criteria-title-box">
                            <h5>Future State Ability to Win:</h5>
                            <span>Re-calculate your Ability to Win weightings and ratings based on your Step 1 ideas, and see how it improves you score</span>
                          </div>
                      }
                    </div>
                  </div>
                  <div className="card-body">
                    {!this.state.createNewTabPending && (
                      <WeightBenefitsTabs
                        tabs={this.state.tabs}
                        challengeStatementData={
                          this.props.challengeStatement
                            .getChallengeStatementData
                        }
                        benefitsData={this.state.benefitsData}
                        competeData={this.state.competeData}
                        oldData={this.state.oldData}
                        onChangeWT={this.onChangeWT}
                        onChangeCCWT={this.onChangeCCWT}
                        onChangeCriticalCapability={
                          this.onChangeCriticalCapability
                        }
                        countCCWT={this.state.countCCWT}
                        competitorsGroupsData={this.state.competitorsGroupsData}
                        onChangeCompetitors={this.onChangeCompetitors}
                        onChangeRatingValue={this.onChangeRatingValue}
                        onChangeCompetitorsRatingValue={
                          this.onChangeCompetitorsRatingValue
                        }
                        result={this.props.result}
                        onDelete={this.onDelete}
                        onAdd={this.onAdd}
                        groupStepState={this.props.groupStepState}
                        benefits={this.props.benefits}
                        differentialAdvantageData={
                          this.props.differentialAdvantageData
                        }
                        onAddNewBenefit={this.onAddNewBenefit}
                        onChangeNewBenefitName={this.onChangeNewBenefitName}
                        onClickPlus={this.onClickPlus}
                        onClickMin={this.onClickMin}
                        tabStep={this.props.tabStep}
                        onTabChange={this.props.onTabChange}
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    {this.props.result ? (
                      <div>
                        <Link
                          to={"/positioning-statement/" + this.props.projectId}
                          className="btn btn-success"
                        >
                          {" "}
                          Next{" "}
                        </Link>
                        <Link to="/toolkit" className="btn btn-success">
                          {" "}
                          Done{" "}
                        </Link>
                        <div
                          className="btn empty-btn default"
                          onClick={this.downloadPDF}
                        >
                          Save PDF
                        </div>
                        <div
                          className="btn empty-btn default"
                          onClick={this.printPage}
                        >
                          Print
                        </div>
                        <div
                          className="btn empty-btn default"
                          onClick={() => this.props.groupStateBack()}
                        >
                          Back
                        </div>
                      </div>
                    ) : (
                      <div>
                        <div
                          className="btn btn-success"
                          onClick={() => this.onNextButtonClick()}
                        >
                          Next
                        </div>
                        {/* <a href="/toolkit" className='btn empty-btn default'>Back</a> */}
                        <div
                          className="btn empty-btn default"
                          onClick={() => this.props.groupStateBack()}
                        >
                          Back
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          {this.props.compete.competeFetching && (
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">{this.elementInfiniteLoad()}</div>
              </div>
            </div>
          )}

          {this.state.abilityToCompeteError && (
            <AbilityToCompeteError
              abilityToCompeteErrorModal={this.abilityToCompeteErrorModal}
            />
          )}
        </div>
      </div>
    );
  }
}
export default RateBenefits;



// WEBPACK FOOTER //
// ./src/components/DifferentialAdvantage/RateBenefits/RateBenefits.jsx